export default {"src":"/_next/static/media/icon-close-hoverd.0e08fe99.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};